import { AppLink } from '@adapters';
import Container from '@modules/common/components/container';

import LogoWhite from './logo_white.svg';

/**
 * Footer link configuration
 */
const footerLinks = [
  { name: '關於火星生技', path: '/about' },
  { name: '最新消息', path: '/latest' },
  { name: '聯絡我們', path: '/contact' },
  { name: '常見問題', path: '/faq' },
];

/**
 * Footer 元件，使用 AppLink 處理 SPA 內部導航和外部連結。
 */
export default function Footer() {
  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer w-full">
      <Container className="flex w-full flex-col">
        <div className="flex flex-col items-center justify-between gap-y-6 py-20 xsmall:flex-row">
          {/* Logo - links to home */}
          <AppLink
            href="/"
            className="txt-compact-xlarge-plus text-ui-fg-subtle hover:text-ui-fg-base uppercase"
          >
            <img
              src={LogoWhite}
              className="w-[160px]"
              width={640}
              height={160}
              alt="logo"
            />
          </AppLink>

          {/* Footer links */}
          {footerLinks.map((link, idx) => (
            <AppLink key={idx} href={link.path} onClick={handleScrollTop}>
              <p className="cursor-pointer">{link.name}</p>
            </AppLink>
          ))}
        </div>
      </Container>
    </footer>
  );
}
